// extracted by mini-css-extract-plugin
export var animationContainer = "_hz-0";
export var asteriskIcon = "_hz-8";
export var conversationLeftSection = "_hz-4";
export var conversationListItem = "_hz-3";
export var conversationMiddleSection = "_hz-5";
export var conversationRightSection = "_hz-6";
export var detailsContent = "_hz-1";
export var listContainer = "_hz-7";
export var modalContent = "_hz-2";